export default __webpack_public_path__ + "static/media/data-safe.54774172.png";